/*
    Formatter 422 errors for display in the UI
*/
export function formatErrors(errors) {
    const errorStrings = []

    Object.keys(errors).forEach(error => {
        errorStrings.push(...errors[error]);
    })

    return errorStrings.join(' | ')
}

export function errorPromise(errors, customErrorMessage) {
    let errorBlock

    if (errors.response.status === 422) {
        errorBlock = errors.response.data.errors
    } else {
        errorBlock = { error: [ customErrorMessage ] }
    }

    return Promise.reject(errorBlock)
}
